import type { CoinView } from './model';
import { predictionState } from './predictionState';

export function cardVisualState(coin: CoinView, now: number) {
  const { kind } = predictionState(coin, now);
  if (kind === 'final')
    return coin.choice
      ? coin.choice === coin.outcome
        ? 'win'
        : 'lose'
      : 'final';
  if (kind === 'pending' || kind === 'result') return kind;
  if (coin.choice) return 'bought';
  if (coin.phase === 'opening') return 'opening';
  return coin.phase === 'open' ? 'active' : 'closed';
}
